import React, {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {Button} from '../components/UI/Button'
import {Pod24CommonLayout} from '../layouts/Pod24CommonLayout'
import {useUserStore} from "../stores/user-store";
import {useAuthStore} from "../stores/auth-store";

export const SocialSignupCompletePage: React.FC = () => {
  const {user} = useAuthStore();

  const [displayingName, setDisplayingName] = useState('OOO');
  const navigate = useNavigate()
  const handleLater = () => {
    navigate('/')
  }

  const handleEmailVerification = () => {
    // TODO: 이메일 인증 로직 구현
    console.log('이메일 인증 처리')
    // 임시로 홈으로 이동
    navigate('/')
  }

  return (
    <Pod24CommonLayout>
      <div className="flex justify-center px-4" style={{paddingTop: '215px'}}>
        <div className="w-full max-w-md text-center">
          {/* 환영 메시지 */}
          <div className="mb-12">
            <h1 className="font-['Pretendard'] font-semibold text-gray-900 mb-6" style={{fontSize: '24px'}}>
              환영합니다
            </h1>
            <p className="mb-4" style={{fontSize: '16px'}}>
              <span className="font-['Pretendard'] font-bold text-blue-600">{user?.name}</span>
              <span className="font-['Pretendard'] font-semibold text-gray-900">님 회원가입이 완료되었습니다!</span>
            </p>
            <div className="font-['Pretendard'] font-normal text-gray-500" style={{fontSize: '14px', height: '36px', marginTop: '16px'}}>
              <p>이메일을 인증하고 더 많은 혜택을 받아보실 수 있습니다</p>
              <p>다음에 다시한 인증하실 수 있어요!</p>
            </div>
          </div>

          {/* 버튼들 */}
          <div className="flex justify-between" style={{gap: '16px', marginBottom: '239px'}}>
            {/* 다음에 하기 버튼 */}
            <button
              onClick={handleLater}
              className="border-2 border-blue-500 rounded-lg text-blue-500 font-['Pretendard'] font-semibold transition-colors hover:bg-blue-50"
              style={{fontSize: '16px', width: '272px', height: '48px', borderRadius: '8px'}}
            >
              다음에 하기
            </button>

            {/* 이메일 인증하기 버튼 */}
            <Button
              onClick={handleEmailVerification}
              className="bg-blue-600 hover:bg-blue-700 text-white font-['Pretendard'] font-semibold transition-colors"
              style={{fontSize: '16px', width: '272px', height: '48px', borderRadius: '8px'}}
            >
              이메일 인증하기
            </Button>
          </div>
        </div>
      </div>
    </Pod24CommonLayout>
  )
}